import color_options from '$tablet-app/src/app/calendar/color_options';
import Row from '$tablet-app/src/app/components/Row';
import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { palette } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import styled from 'styled-components/native';
import { FormCollapsableSection } from '../FormCollapsableSection';
import { FormRowIcon } from '../FormRowIcon';

interface Props<T> {
  section: T;
  expanded?: boolean;
  value?: string;
  onChange?(value: string): void;
  onPress?(section: T): void;
}

const FormColorSection = <T,>(props: Props<T>) => {
  const { onChange, value, ...rest } = props;

  return (
    <FormCollapsableSection
      {...rest}
      left={
        <Row alignItems="center">
          <FormRowIcon icon="palette" />
          <Spacer width="8px" />
          <Text>Color</Text>
        </Row>
      }
      right={value ? <ColorPill style={{ backgroundColor: value }} /> : null}
    >
      <ColorOptionsRow>
        {color_options.map((opt) => (
          <TouchableColorPill
            key={opt}
            active={value === opt}
            style={{ backgroundColor: opt }}
            onPress={() => onChange?.(opt)}
          >
            {value === opt ? (
              <FontAwesomeIcon
                icon="check"
                size={26}
                color={palette.primary_700}
              />
            ) : null}
          </TouchableColorPill>
        ))}
      </ColorOptionsRow>
    </FormCollapsableSection>
  );
};

const ColorPill = styled.View`
  height: 40px;
  width: 40px;
  border-radius: 10px;
  border-width: 2px;
  border-color: ${palette.primary_700};
`;

const TouchableColorPill = styled.TouchableOpacity<{ active?: boolean }>`
  height: 56px;
  width: 56px;
  border-radius: 20px;
  border-width: 2px;
  border-color: ${({ active }) => (active ? palette.primary_700 : 'white')};
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
  margin: 8px;
  align-items: center;
  justify-content: center;
`;

const ColorOptionsRow = styled.View`
  margin-top: 16px;
  flex-direction: row;
  flex-wrap: wrap;
`;

export default FormColorSection;
